import alert from '@/utils/alert.js';

export default {
  install(app) {
    app.config.globalProperties.$alert = alert; // Tambahkan `alert` ke globalProperties
  },
};